function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30 0H0v30h30V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#LTC_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 28.377c7.388 0 13.377-5.99 13.377-13.377 0-7.388-5.99-13.377-13.377-13.377C7.612 1.623 1.623 7.614 1.623 15c0 7.388 5.99 13.377 13.377 13.377z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 0a15 15 0 1015 15A14.958 14.958 0 0015.087 0H15zm.254 15.508l-1.561 5.267h8.353a.42.42 0 01.436.407v.138l-.726 2.506a.542.542 0 01-.545.4H8.426l2.143-7.301-2.397.726.545-1.67 2.397-.727 3.014-10.242a.547.547 0 01.545-.4h3.232a.422.422 0 01.436.407v.138L15.8 13.802l2.397-.727-.508 1.743-2.434.69z",
  fill: "#345D9D"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "LTC_svg__clip0_1_69"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgLtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LTC_svg__clip0_1_69)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "LTC_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _ref), _ref2), _ref3);
}

export default __webpack_public_path__ + "2120221d8690f1e530bb3169a1bb2449.svg";
export { SvgLtc as ReactComponent };